import React, { useCallback, useState } from 'react';
import DataGrid, {
    Column, Paging, Scrolling, Selection,
} from 'devextreme-react/data-grid';
import DropDownBox from 'devextreme-react/drop-down-box';

const dropDownOptions = { width: 500 };
const ownerLabel = { 'aria-label': 'Owner' };
export const TimeDropdownBox = (props) => {
    const {
        data: { value: dataValue },
    } = props;
    const initialSelectedRowKeys = dataValue !== null && dataValue !== undefined ? [dataValue] : [];
    const [selectedRowKeys, setSelectedRowKeys] = useState(initialSelectedRowKeys);
    const [isDropDownOpened, setDropDownOpened] = useState(false);
    const boxOptionChanged = useCallback((e) => {
        if (e.name === 'opened') {
            setDropDownOpened(e.value);
        }
    }, []);
    const contentRender = useCallback(() => {
        const onContextMenuPreparing = (event) => {
            event.items = [];
        };
        const onSelectionChanged = (args) => {
            setSelectedRowKeys(args.selectedRowKeys);
            setDropDownOpened(false);
       //     props.data.setValue(args.selectedRowKeys[0]);
        };
        return (
            <DataGrid
                keyExpr={'resultId'}
                dataSource={props.data.value}
                remoteOperations={false}
                height={250}
                selectedRowKeys={selectedRowKeys}
                hoverStateEnabled={true}
                onContextMenuPreparing={onContextMenuPreparing}
                onSelectionChanged={onSelectionChanged}
                focusedRowEnabled={true}
            >
                <Column dataField="swimtime" />
                <Column dataField="date" />
                <Column dataField="competitionName" />
                <Column dataField="city" />
                <Column dataField="course" />
                <Column dataField="best" />
                <Column dataField="split" />
                <Column dataField="qualification"/>

                <Paging
                    enabled={true}
                    defaultPageSize={10}
                />
                <Scrolling mode="virtual" />
                <Selection mode="single" />
            </DataGrid>
        );
    }, [props.data, selectedRowKeys]);
    return (
        <DropDownBox
            onOptionChanged={boxOptionChanged}
            opened={isDropDownOpened}
            dropDownOptions={dropDownOptions}
            dataSource={props.data.value}
            value={selectedRowKeys[0]}
            displayExpr="FullName"
            valueExpr="ID"
            inputAttr={ownerLabel}
            contentRender={contentRender}
        ></DropDownBox>
    );
};

export const TimeDropdownBoxCounter = (props) => { 
    return (
  <div>
    <span>{props.data?.value?.length != 0 ? props.data?.value?.length + ' Zeiten vorhanden' : ''}</span>
  </div>)
};